<template>
  <div class="app-container xmzk_z">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="110px"
      >
        <el-form-item label="部门名称:" prop="courseGroup">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            :disabled="!isZg"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="(val) => handleChangeBm(val, 'bmbh')"
            clearable
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目状态:" prop="xmzt">
          <el-select
            ref="name"
            v-model="listQuery.xmzt"
            placeholder="全部"
           
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
            @change="(val) => handleChangeBm(val, 'xmzt')"
          >
            <el-option
              v-for="item in xmztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="项目名称:" prop="xmmc">
          <el-select
            ref="xmbh"
            v-model="listQuery.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 200px"
            class="filter-item xmmc"
            clearable
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="项目编号:" prop="svnNumber">
          <el-select
            ref="svnNumber"
            v-model="listQuery.svnNumber"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in svnList"
              :key="item.num"
              :label="item.num"
              :value="item.num"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="项目类型:" prop="zbmc">
          <el-select
            ref="xmlx"
            v-model="listQuery.xmlx"
            placeholder="项目类型"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmlxList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="检测状态:" prop="ischeck">
          <el-select
            ref="ischeck"
            v-model="listQuery.ischeck"
            placeholder="全部"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option label="全部" value="" />
            <el-option label="通过" value="1" />
            <el-option label="不通过" value="2" />
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block; margin-left: 40px">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >搜索</el-button
          >
          <el-button
            type="primary"
            size="small"
            style="margin-left: 15px"
            @click="handleToYjPass"
            v-if="isZg"
            >一键处理</el-button
          >
          <el-button
            type="primary"
            size="small"
            style="margin-left: 15px"
            @click="handleExport"
            v-if="isZg"
            >导出</el-button
          >
          <el-button
            icon="el-icon-refresh"
            size="small"
            class="filter-item"
            style="margin-left: 15px"
            @click="reset"
            >重置</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        border
      >
        <!-- <el-table-column
          label="申请id"
          prop="sqid"
          align="center"
          min-width="0px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        >  <template slot-scope="scope">
            <span>{{ scope.row.sqid }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          label="操作"
          align="center"
          min-width="120px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
          v-if="isZg"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="handleToEdit(scope.row)"
              style="padding: 0"
              >编辑</el-button
            >
            <el-button
              size="small"
              type="text"
              style="padding: 0; color: #d9001b; margin-left: 15px"
              @click="handleToPass(scope.row)"
              >处理</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="部门名称"
          prop="bmmc"
          align="center"
          min-width="100px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="项目名称"
          prop="xmjc"
          align="center"
          min-width="200px"
          class-name="small-padding fixed-width"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmjc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目编号"
          prop="svn_number"
          :show-overflow-tooltip="true"
          min-width="80px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.svn_number }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="检测状态"
          prop="ischeck"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span v-show="scope.row.ischeck == '通过'" style="color: #036eb8">{{
              scope.row.ischeck
            }}</span>
            <span
              v-show="scope.row.ischeck == '不通过'"
              style="color: rgb(217, 0, 27)"
              >{{ scope.row.ischeck }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="项目类型"
          prop="xmlxmc"
          min-width="100px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmlxmc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          label="项目状态"
          prop="xmzt"
          min-width="130px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.xmzt }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="合同周期"
          prop="htzq"
          min-width="180px"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.htzq }}</span>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      title="处理"
      :visible.sync="passResultDialog"
      width="1100px"
      :closeOnClickModal="false"
      v-if="passResultDialog"
      class="svn_pass_dialog"
    >
      <div>
        <div class="pass_info">
          <div>
            <span>项目名称 </span> <span>{{ passInfo.info.xmjc }}</span>
          </div>
          <div>
            <span>项目编号 </span> <span>{{ passInfo.info.svn_number }}</span>
          </div>
        </div>
        <div>
          <el-table
            :data="passInfo.list"
            fit
            highlight-current-row
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
            :header-cell-style="tableHeaderColor"
            border
          >
            <el-table-column
              label="计划名称"
              align="center"
              prop="pname"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="关键动作/规划"
              align="center"
              prop="jname"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="关联目录结构"
              align="center"
              prop="dir"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="异常提醒"
              align="center"
              prop="message"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
             <el-table-column
              label="异常触发时间"
              align="center"
              prop="createtime"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passResultDialog = false">取消</el-button>
        <el-button type="primary" @click="handlePassSvn(passInfo.info.xmbh, 2)"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="editDialog"
      class="editDialog"
    >
      <div>
        <el-form
          ref="editInfoFrom"
          :model="editInfo"
          label-width="120px"
          class="userManage-from"
          :rules="editInfoRules"
        >
          <el-form-item label="部门名称：" prop="editInfoBmmc">
            <el-input v-model="editInfo.bmmc" disabled></el-input>
          </el-form-item>
          <el-form-item label="项目名称：" prop="editInfoXmmc">
            <el-input v-model="editInfo.xmjc" disabled></el-input>
          </el-form-item>
          <el-form-item label="项目类型：" prop="editInfoXmlx">
            <el-input v-model="editInfo.xmlxmc" disabled></el-input>
          </el-form-item>
          <el-form-item label=" 项目阶段：" prop="editInfoXmjd">
            <el-input v-model="editInfo.xmjd" disabled></el-input>
          </el-form-item>
          <el-form-item label="项目编号：" prop="svn_number">
            <el-input v-model="editInfo.svn_number" maxlength="30"></el-input>
          </el-form-item>
            <div v-if="showCheckRes"  style="color: red; margin-top: 5px; margin-left : 40px">
                存在相同的SVN编号：{{checkRes}}
            </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取消</el-button>
        <el-button type="primary" @click="handleEdit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="一键处理"
      :visible.sync="yjclDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="yjclDialog"
      class="svn_pass_dialog"
    >
      <div class="yjcl">
        共计 <span>{{ xms }}</span> 个项目，需要处理模型节点与SVN目录匹配错误
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="yjclDialog = false">取消</el-button>
        <el-button type="primary" @click="handlePassSvn('', 1)">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getDict } from "@/api/common";
import { getXmxxList3 } from "@/api/itWeekly";
import { getBmxxList } from "@/api/itWeekly.js";
import {
  exportSvnManage,
  getSvnManageList,
  getXmPlanModelList,
  getXmSvnBhList,
  isZgRole,
  saveSvnManage,
  checkSvnNumber,
  svnManageSolve,
  svnManageXmsSolve,
} from "@/api/svn";
import { getDictData } from "@/api/weekly.js";
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";

export default {
  // 列表分页
  name: "taskType",
  components: { Pagination },
  computed: {
    ...mapGetters(["user", "zxlc"]),
  },
  data() {
    return {
      height: 100,
      listQuery: {
        bmbh: "",
        xmbh: [],
        svnNumber: "",
        xmlx: "",
        xmzt: "1",
        ischeck: "",
        page: 1,
        pageSize: 50,
      },
      listLoading: true,
      total: 0,
      list: [],
      passResultDialog: false,
      editDialog: false,
      yjclDialog: false,
      bmList: [],
      xmList: [],
      xmlxList: [],
      xmztList: [],
      svnList: [],
      passInfo: {
        info: {},
        list: [],
      },
      editInfo: {
        svn_number: "",
      },
      params: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        xmlx: "DS,MC,PC,PX,RW,SD,SW,TS", //说明：项目类型，多个,隔开
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        xmzt: "1", //项目状态，多个,隔开，如1,3
        //xmzt: "1,2,3,5",
      },
      isZg: true,
      xms: 0,
      editInfoRules: {
        svn_number: [
          { required: true, message: "项目编号不能为空", trigger: "change" },
        ],
      },
      showCheckRes:false,
      checkRes:null,
    };
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
        if (res.code == 0) {
          getBmxxList(this.params.type, this.params.range).then((res) => {
            if (res.code == 0) {
              this.bmList = res.data;
              if (this.user.bmbh != "0080") {
                this.listQuery.bmbh = this.user.bmbh;
              }
              this.getList();
              getXmxxList3(
                this.params.xmlx,
                this.params.range,
                this.params.xmzt,
                this.listQuery.bmbh,
                ""
              ).then((res) => {
                if (res.code == 0) {
                  this.xmList = res.data;
                }
              });
              getXmSvnBhList(this.listQuery.bmbh).then((res) => {
                if (res.code === 0) {
                  this.svnList = res.data;
                  this.listQuery.svnNumber=""
                }
              });
            }
          });
        }
      });
    }
    // 获取项目阶段数据
    getDictData("xmjd", 2).then((res) => {
      if (res.code == 0) {
        this.xmjd = res.data.splice(0, 3);
      }
    });

    getDict("htgl_xmlx", "2").then((res) => {
      if (res.code == 0) {
        res.data.forEach((item) => {
          if (item.dictValue != "SQ") {
            this.xmlxList.push(item);
          }
        });
      }
    });

    getDict("xmgl_xmzt", "2").then((res) => {
      if (res.code == 0) {
        this.xmztList = res.data;
      }
    });

    // 获取审批状态
    getDictData("pmp_zkgl_shzt", 1).then((res) => {
      if (res.code == 0) {
        this.spztList = res.data;
      }
    });
    if (this.zxlc.xmztList.length == 0) {
      this.$store.dispatch("zxlc/fetchHtztListAction", {
        dictType: "xmzt",
        type: 2,
      });
    }
    isZgRole().then((res) => {
      if (res.data == 0) {
        this.isZg = res.data == 1;
      }
    });
    // getXmSvnBhList().then((res) => {
    //   if (res.code == 0) {
    //     this.svnList = res.data;
    //   }
    // });
  },
  methods: {
    getList() {
      const { bmbh, xmbh, svnNumber, xmlx, xmzt, ischeck, page, pageSize } =
        this.listQuery;

      const params = {
        bmbh,
        xmbh: xmbh.join(","),
        svnNumber,
        xmlx,
        xmzt,
        ischeck,
        page,
        pageSize,
      };
      getSvnManageList(params).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    reset() {
      // 重置
      this.listQuery = {
        ...this.listQuery,
        ...{
          xmbh: [],
          svnNumber: "",
          xmlx: "",
          xmzt: "",
          ischeck: "",
        },
      };
      if (this.isZg) {
        this.listQuery.bmbh = "";
      }
    //   getXmSvnBhList().then((res) => {
    //   if (res.code == 0) {
    //      this.svnList = res.data;
    //    }
    //  });
    },
    handleToPass(row) {
      this.passResultDialog = true;

      this.passInfo.info = row;
      getXmPlanModelList({ xmbh: row.xmbh }).then((res) => {
        if (res.code == 0) {
          this.passInfo.list = res.data;
        }
      });
    },
    handleToEdit(row) {
      this.editDialog = true;
      this.editInfo = row;
           const checkParams = {
        xmbh: this.editInfo.xmbh,
        svnNumber:this.editInfo.svn_number? this.editInfo.svn_number.trim():'',
      };
       checkSvnNumber(checkParams)
            .then((checkRes) => {
                 if (checkRes.code === 0 && checkRes.msg !== "操作成功") {
                   this.checkRes = checkRes.msg
                   this.showCheckRes =   true
                 }else{
                   this.showCheckRes = false
                 }
            });
    },

    handleChangeBm(val, key) {
      if (key === "bmbh") {
        this.listQuery.bmbh = val;
      } else if (key === "xmzt") {
        this.listQuery.xmzt = val;
      }
      getXmxxList3(
        this.params.xmlx,
        this.params.range,
        this.listQuery.xmzt,
        this.listQuery.bmbh
      ).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          this.listQuery.xmbh=[]
        }
      });
      getXmSvnBhList(this.listQuery.bmbh).then((res) => {
        if (res.code === 0) {
          this.svnList = res.data;
          this.listQuery.svnNumber=""
        }
      });
    },

    handleEdit() {
      const params = {
        xmbh: this.editInfo.xmbh,
        svnNumber: this.editInfo.svn_number,
      };
      saveSvnManage(params).then((res) => {
        if (res.code == 0) {
          this.editDialog = false;
          this.$message.success(res.msg);
          this.getList();
          getXmSvnBhList().then((res) => {
        if (res.code === 0) {
          this.svnList = res.data;
        }
      })
        }
      });

    },


    handleSaveSvnManage() {
      const saveParams = {
        xmbh: this.editInfo.xmbh,
        svnNumber: this.editInfo.svn_number.trim(),
      };

      saveSvnManage(saveParams)
        .then((saveRes) => {
          if (saveRes.code === 0) {
            this.editDialog = false;
            this.$message.success(saveRes.msg);
            getXmSvnBhList()
              .then((svnListRes) => {
                if (svnListRes.code === 0) {
                  this.svnList = svnListRes.data;
                }
              })
              .catch((error) => {
                // 处理 getXmSvnBhList() 错误
                console.error("操作失败", error);
              });

            this.getList();
          }
        })
        .catch((error) => {
          // 处理 saveSvnManage() 错误
          console.error("操作失败", error);
        });
    },
    handlePassSvn(xmbh, type) {
      svnManageSolve({ xmbh, type }).then((res) => {
        if (res.code == 0) {
          this.passResultDialog = false;
          this.$message.success(res.msg);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleToYjPass() {
      this.yjclDialog = true;
      svnManageXmsSolve().then((res) => {
        if (res.code == 0) {
          this.xms = res.data;
        }
      });
    },
    handleExport() {
      // const params = this.listQuery;
      // params.xmbh = params.xmbh.join(",");
      const { bmbh, xmbh, svnNumber, xmlx, xmzt, ischeck, page, pageSize } =
        this.listQuery;

      const params = {
        bmbh,
        xmbh: xmbh.join(","),
        svnNumber,
        xmlx,
        xmzt,
        ischeck,
        page,
        pageSize,
      };
      exportSvnManage(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  font-family: "Arial Negreta" !important;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.text_btn {
  cursor: pointer;
  color: #036eb8;
}
::v-deep .svn_pass_dialog .el-dialog__body {
  padding-top: 0;
}
.pass_info {
  display: flex;
  line-height: 44px;
  font-size: 16px;
  color: #aaaaaa;
  margin-bottom: 15px;
  > div {
    margin-right: 15px;
    span:nth-of-type(2) {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
.yjcl {
  height: 44px;
  line-height: 44px;
  text-align: center;
  font-size: 16px;
  span {
    font-weight: bold;
  }
}
</style>
